import '../css/style.css'; // this is necessary to have the css processed

import Swiper from 'swiper';
import { Autoplay, EffectFade, Navigation } from 'swiper/modules';
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

document.addEventListener('DOMContentLoaded', init);
window.addEventListener('load', initAfterLoad);
window.addEventListener('resize', initAfterResize);

// called after DOMContentLoaded, before everything is complete
function init() {
  initMainMenu();
  initStoerer();
  initProjectsSwiper();
  initProjectsSliderSimple();
  initJobStoerer();
  initAccordion();
  initAccordionProjectsFade();
  initAccordionSimple();
  initProjectMoreLess();
  initImageHoverModal();
  initProjectFilterBar();
  initCardPopup();
  initJoboffers();
  disableImageRightClick();
}

// called after window.load, when all other elements are loaded
function initAfterLoad() {
}

// resize
function initAfterResize() {
}

function disableImageRightClick() {
  const els = document.querySelectorAll('img, video') as NodeListOf<HTMLImageElement>;
  els.forEach((el) => {
    el.addEventListener('contextmenu', (e) => e.preventDefault());
  })
}

async function initMainMenu() {
  const menu = document.querySelector('.main-navbar .menu') as HTMLDivElement|null;
  if (!menu) return;

  const open = menu.querySelector('.menu-open') as HTMLDivElement|null;
  const close = menu.querySelector('.menu-close') as HTMLDivElement|null;

  open?.addEventListener('click', openMenu);
  close?.addEventListener('click', closeMenu);

  function openMenu() {
    menu!.classList.add('open');
    window.addEventListener('keydown', escClose);
  }

  function closeMenu() {
    menu!.classList.remove('open');
    window.removeEventListener('keydown', escClose);
  }

  // close on esc function
  function escClose (e: KeyboardEvent) {
    if (e.key == 'Escape') {
      closeMenu();
      e.preventDefault();
    }
  }
}

async function initStoerer() {
  const animationDurationMs = 200;
  const animationDelay = 2000;

  const wordAnimations = document.querySelectorAll('[data-wordanimation]');
  wordAnimations.forEach((wordAnimation, i) => {
    const breadcrumb = wordAnimation.getAttribute('data-wordanimation');
    if (!breadcrumb) return;

    const words = (wordAnimation.getAttribute('data-wordanimation-words') || '').split(';');
    if (!words) return;

    words.unshift(breadcrumb);

    const text = wordAnimation.innerHTML;
    const replacePos = text.lastIndexOf(breadcrumb);
    if (replacePos === -1) return;

    const textBefore = text.substring(0, replacePos);
    const textAfter = text.substring(replacePos + breadcrumb.length);

    let mostChars = 0;
    words.forEach((w) => mostChars = Math.max(mostChars, w.length));
    const id = `wordanimation-${i}`;
    const animationSpan = '<span id="'+id+'" style="transition: opacity '+ animationDurationMs +'ms ease-in-out; display: inline-block; min-width:'+Math.round(mostChars/1.2)+'em;">'+words[0]+'</span>';

    wordAnimation.innerHTML = textBefore + animationSpan + textAfter;

    // insert words with timer
    const wordContainer = wordAnimation.querySelector(`#${id}`) as HTMLSpanElement|null
    if (!wordContainer) return;

    let j = 0;
    setInterval(() => {
      wordContainer.innerHTML = words[j];
      wordContainer.style.opacity = '1';
      
      setTimeout(() => {
        wordContainer.style.opacity = '0';
      }, animationDelay);
      
      j = (j+1) % words.length;
    }, animationDurationMs+animationDelay);
  });
}

function initProjectsSwiper() {
  const swipers = document.querySelectorAll('.projects-slider') as NodeListOf<HTMLDivElement>;

  if (swipers.length === 0) {
    return;
  }

  swipers.forEach((swiper) => {
    new Swiper(swiper, {
      modules: [Navigation],
      navigation: {
        enabled: true,
        nextEl: '.control-right',
        prevEl: '.control-left',
      },
      rewind: true,
    });
  });
}

function initProjectsSliderSimple() {
  const swipers = document.querySelectorAll('.projects-slider-simple') as NodeListOf<HTMLDivElement>;

  if (swipers.length === 0) {
    return;
  }

  swipers.forEach((swiper) => {
    new Swiper(swiper, {
      modules: [Navigation],
      navigation: {
        enabled: true,
        nextEl: '.control-right',
      },
      rewind: true,
      slidesPerView: 1,
      spaceBetween: 16,
      breakpoints: {
        600: {
          slidesPerView: 2,
        },
        1025: {
          slidesPerView: 3,
        },
      }
    });
  });
}

function initJobStoerer() {
  const jobImages = document.querySelectorAll('.job-stoerer .job-image') as NodeListOf<HTMLImageElement>;
  const jobOverlays = document.querySelectorAll('.job-stoerer .job-overlay') as NodeListOf<HTMLDivElement>;

  if (jobImages.length === 0 || jobImages.length !== jobOverlays.length) {
    return;
  }

  jobImages.forEach((image, i) => {
    image.addEventListener('mouseenter', () => {
      jobOverlays[i].style.opacity = '1';
    });

    image.addEventListener('mouseout', () => {
      jobOverlays[i].style.opacity = '0';
    });
  });
}

/**
 * accordion which highjacks the page scroll to transition elements into view one after another, then resumes page scroll
 * @returns 
 */
function initAccordion() {
  const accordion = document.querySelector('.accordion-section .accordion') as HTMLDivElement|null;
  if (!accordion) return;

  // find max slide height, set all slides to the same height
  const slides = accordion.querySelectorAll('.slide') as NodeListOf<HTMLDivElement>;
  let maxH = 0;

  slides.forEach((slide) => {
    maxH = Math.round(Math.max(maxH, slide.getBoundingClientRect().height));
  });

  const isMobile = window.innerWidth < 1024;
  
  // set accordion h, position slides
  slides.forEach((slide, i) => {
    // all the same height on desktop, mobile collapse to screen height if space available
    const h = isMobile ? Math.max(Math.min(maxH, slide.offsetHeight), window.innerHeight) : maxH;
    slide.style = `z-index: ${i+1}; height: ${h}px;`;
  });

  // projects wrapper as well
  const projectsWrapper = document.querySelector('.projects-wrapper') as HTMLDivElement|null;
  if (projectsWrapper && !isMobile) {
    projectsWrapper.style.height = accordion.offsetHeight + 'px';

    const projects = projectsWrapper.querySelector('.projects') as HTMLDivElement;
    if (projects) projects.style.top = (window.innerHeight - maxH) + 'px';
  }

  // animate it
  gsap.registerPlugin(ScrollTrigger);

  slides.forEach((slide, i) => {
    const isLastSlide = i >= slides.length-1;

    ScrollTrigger.create({
      trigger: slide as HTMLDivElement,
      start: () => `top ${window.innerHeight - slide.offsetHeight}px`,
      end: () => !isLastSlide ? `+=${slide.offsetHeight}px` : window.innerHeight,
      pin: true,
      scrub: true,
      pinSpacing: false,
      // snap: 1,
      markers: false,
      id: 'slide_'+i,
      onLeave: (st) => !isLastSlide ? slide.classList.add('hidden') : null,
      onEnterBack: (st) => slide.classList.remove('hidden'),
    });
  });

  window.addEventListener('resize', () => {
    // reload page
    window.location.href = window.location.href;
  });
}

function initAccordionSimple() {
  const accordion = document.querySelector('.accordion-simple') as HTMLDivElement|null;
  if (!accordion) return;

  // find max slide height
  const slides = accordion.querySelectorAll('.slide') as NodeListOf<HTMLDivElement>;

  let timeout = false; // after opening wait a moment before allowing a new open

  let openSlideNo: number|null = null;
  slides.forEach((slide, i) => {
    slide.addEventListener(isTouchDevice() ? 'click' : 'mouseenter', () => {
      if (!timeout) {
        timeout = true;
        setTimeout(() => timeout = false, isTouchDevice() ? 200 : 100);
        
        slides.forEach((s) => {
          s.classList.toggle('open', slide === s);
          s.classList.toggle('other-open', slide !== s);
        });

        if (openSlideNo !== null && isTouchDevice()) {
          // if already a tab is open scroll to new tab y
          if (openSlideNo < i) {
            // if opening slide below currently openend, calc new position
            let futureY = slides[0].offsetTop;
            for (let s = 0; s < i; s++) {
              futureY += slides[s].querySelector('.hl-wrapper')?.getBoundingClientRect().height || 10;
            }

            window.scrollTo({
              behavior: 'smooth',
              left: 0,
              top: futureY - 36, // scroll directly to new header if 
            });
          } else if (openSlideNo > i) {
            // if opening slide above currently openend, just scroll to newly opened tab
            window.scrollTo({
              behavior: 'smooth',
              left: 0,
              top: slides[i].offsetTop - 36, // scroll directly to new header if 
            });
          }
        }
      }

      openSlideNo = i;
    });
  });
}

function initAccordionProjectsFade() {
  const swipers = document.querySelectorAll('.accordion-section .projects .swiper') as NodeListOf<HTMLDivElement>;

  swipers.forEach((swiper) => {
    new Swiper(swiper, {
      modules: [Autoplay, EffectFade],
      effect: 'fade',
      allowTouchMove: false,
      loop: true,
      autoplay: {
        delay: 2500,
        disableOnInteraction: false,
        pauseOnMouseEnter: false,
        stopOnLastSlide: false,
      }
    });
  });
}

function initProjectMoreLess() {
  const moreLessContainer = document.querySelector('.more-less-container') as HTMLDivElement;
  if (!moreLessContainer) return;

  const btnMore = moreLessContainer.querySelector('.btn-more');
  const btnLess = moreLessContainer.querySelector('.btn-less');
  const morePopup = moreLessContainer.querySelector('.more');
  if (!btnMore || !btnLess || !morePopup) return;

  btnMore.addEventListener('click', () => moreLessContainer.classList.toggle('open'));
  btnLess.addEventListener('click', () => moreLessContainer.classList.toggle('open'));
}

function initImageHoverModal() {
  const images = document.querySelectorAll('[data-img-enlarge]');

  images.forEach((image) => {
    const url = image.getAttribute('data-img-enlarge') || image.getAttribute('src');
    if (!url) return;

    let popup: HTMLDialogElement|null = null;

    image.addEventListener('mouseenter', () => {
      if (popup) return;

      // create popup
      popup = document.createElement('dialog');
      popup.classList.add('image-popup', 'opacity-0', 'transition-all', 'duration-100');

      const img = document.createElement('img');
      img.src = url;

      const btn = document.createElement('button');
      btn.classList.add('close');
      btn.innerHTML = 'X';
      btn.addEventListener('click', close);

      popup.append(img, btn);

      setTimeout(() => {
        // fade in
        if (popup) {
          popup.show();
          popup.style.opacity = '1';
        }
      }, 25);

      document.body.append(popup);

      // add esc listener
      window.addEventListener('keydown', escListener);
    });

    image.addEventListener('mouseleave', () => {
      close();
    });

    function close() {
      if (!popup) return;

      // remove popup + esc listener
      popup.style.opacity = '0';
      setTimeout(() => {
        if (popup) {
          popup.remove();
        }
      }, 100);
      popup = null;
      window.removeEventListener('keydown', escListener);
    }

    function escListener(e: KeyboardEvent) {
      if (e.key === 'Escape') {
        close();
      }
    }
  });
}

function initProjectFilterBar() {
  const form = document.querySelector('.project-search .filter-bar form') as HTMLFormElement|null;
  if (!form) return;

  const selects = form.querySelectorAll('select');
  selects.forEach(select => {
    select.addEventListener('change', () => {
      form.submit();
    });
  });
}

function initCardPopup() {
  const container = document.querySelector('.card-popup-section') as HTMLDivElement|null;
  if (!container) return;

  const card = container.querySelector('.card') as HTMLDivElement;
  const popup = container.querySelector('.popup') as HTMLDivElement;
  if (!card || !popup) return;

  card.addEventListener('click', () => {
    if (popup.classList.contains('open')) {
      closePopup();
    } else {
      openPopup();
    }
  });

  popup.querySelector('.close')?.addEventListener('click', () => {
    closePopup();
  });

  function openPopup() {
    popup.classList.add('open');
    window.addEventListener('keydown', escClose);

    if (window.innerWidth < 1680) {
      disableWindowScroll();
    }
  }

  function closePopup() {
    popup.classList.remove('open');
    window.removeEventListener('keydown', escClose);
    enableWindowScroll();
  }

  // close on esc function
  function escClose (e: KeyboardEvent) {
    if (e.key == 'Escape') {
      closePopup();
      e.preventDefault();
    }
  }
}

function initJoboffers() {
  const joboffers = document.querySelectorAll('.joboffers-section .joboffer') as NodeListOf<HTMLDivElement>;
  if (!joboffers.length) return;

  joboffers.forEach((joboffer) => {
    const button = joboffer.querySelector('.button') as HTMLDivElement;
    const popup = joboffer.querySelector('.popup') as HTMLDivElement;
    if (!button || !popup) return;

    button.addEventListener('click', () => {
      if (popup.classList.contains('open')) {
        closePopup();
      } else {
        openPopup();
      }
    });

    popup.querySelector('.close')?.addEventListener('click', () => {
      closePopup();
    });

    function openPopup() {
      popup.classList.add('open');
      window.addEventListener('keydown', escClose);
      disableWindowScroll();
    }

    function closePopup() {
      popup.classList.remove('open');
      window.removeEventListener('keydown', escClose);
      enableWindowScroll();
    }

    // close on esc function
    function escClose (e: KeyboardEvent) {
      if (e.key == 'Escape') {
        closePopup();
        e.preventDefault();
      }
    }
  });
}

/**
 * disable window scroll
 */
function disableWindowScroll() {
  const html = document.querySelector("html");
  if (html) html.style.overflow = "hidden";
}

/**
 * enable window scroll (after it has been disabled by disableWindowScroll)
 */
function enableWindowScroll() {
  const html = document.querySelector("html");
  if (html) html.style.overflow = "";
}

function isTouchDevice(): boolean {
  return ('ontouchstart' in window) || (navigator.maxTouchPoints > 0);
}